// Re-exported for backwards compatibility. Deprecate and remove in a future major release.
export {
    schemaDraft07 as default,
    createTestSchema,
    TOKEN_PATTERN,
    rgbColorPattern,
    rgbaColorPattern,
    colorPattern,
    colorPatternWithRGBA,
    COLOR_OR_TOKEN_PATTERN,
    COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    DYNAMIC_OPTIONS_DSL_PATTERN,
    getPattern,
} from '@splunk/visualization-schemas';
